// The reason the server gave for refusing a change (a 4xx with an "error" or
// "message"), or null for anything else, so a screen can say WHY instead of
// "please try again" when trying again would never work.
export function serverReason(err) {
  const status = err?.status;
  if (typeof status !== "number" || status < 400 || status >= 500) return null;
  const data = err.data || {};
  const reason = data.message || data.error;
  return typeof reason === "string" && reason.trim() ? reason.trim() : null;
}

// "<what failed>" plus the server's reason in brackets when it gave one.
export function failedMessage(err, message) {
  const reason = serverReason(err);
  return reason ? `${message} (${reason})` : message;
}
